module.exports = __webpack_public_path__ + "static/media/deactiveMemTam.6ca20391.jpg";